import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9 8l-4 4 4 4M15 8l4 4-4 4" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("svg", {
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    xmlns: "http://www.w3.org/2000/svg",
    style: _normalizeStyle($props.color ? { color: $props.color } : undefined)
  }, _hoisted_3, 12, _hoisted_1))
}

import { defineComponent as _defineComponent } from 'vue'

const __script = /*#__PURE__*/_defineComponent({
  __name: 'code.svg',
  props: {
  size: { type: Number, default: 24 },
  color: { type: String, default: undefined },
},
  setup(__props, { expose }) {
  expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})

__script.render = render
export default __script